import { render, staticRenderFns } from "./PosOrderDetails.vue?vue&type=template&id=88be69d4&scoped=true&"
import script from "./PosOrderDetails.vue?vue&type=script&lang=js&"
export * from "./PosOrderDetails.vue?vue&type=script&lang=js&"
import style0 from "./PosOrderDetails.vue?vue&type=style&index=0&id=88be69d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88be69d4",
  null
  
)

export default component.exports